/**
 * Fifi's V3 search empty state: clicking a "Popular right now" tag fills the search input and runs
 * the search through Horizon's predictive-search-component (it only reacts to input events that
 * carry an inputType).
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const tag = target.closest('[data-fifi-search-term]');
  if (!tag) return;

  const input = tag.closest('predictive-search-component')?.querySelector('input[type="search"]');
  if (!(input instanceof HTMLInputElement)) return;

  const term = tag.getAttribute('data-fifi-search-term') ?? '';
  input.value = term;
  input.focus();
  input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }));
});
